export const taboola = (partnersIds) => {
  window._tfa = window._tfa || []
  window._tfa.push({
    notify: 'event',
    name: 'page_view',
  })

  Object.entries(partnersIds).forEach(([partnerId, partnerOptions]) => {
    !(function (t, f, a, x) {
      if (!document.getElementById(x)) {
        t.async = 1
        t.src = a
        t.id = x
        f.parentNode.insertBefore(t, f)
      }
    })(
      document.createElement('script'),
      document.getElementsByTagName('script')[0],
      `//cdn.taboola.com/libtrc/unip/${partnerId}/tfa.js`,
      'tb_tfa_script'
    )

    if ('events' in partnerOptions) {
      callEvents(partnerId, partnerOptions.data, partnerOptions.events)
    }
  })

  function callEvents(partnerId, partnerData, tracks) {
    Object.entries(tracks).forEach(([index, track]) => {
      if (track.type == 'purchase') {
        _tfa.push({
          notify: 'event',
          name: 'make_purchase',
          id: partnerId,
        })
      }
    })
  }
}
